import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Button from '../Buttons/Button';
import BackButton from '../Buttons/BackButton';

const StepsHeader = ({ onBackClick, activeStep, totalSteps, nextText, onNextClick, loading, children, pulseNextButton }) => {
  const backButtonClass = classnames(`back-btn-container flex-center`, {
    'opacity-0': activeStep === 1,
  });

  let nextButtonText;
  if (nextText) {
    nextButtonText = nextText;
  } else {
    nextButtonText = `Continue`;
  }

  return (
    <div className="content-creation-header position-fixed">
      <div className={backButtonClass}>
        <BackButton onClick={onBackClick} />
      </div>

      <div className="content-title flex-center">
        <span>Step {activeStep} of {totalSteps}</span>
      </div>

      {children}

      <div className="flex-center save-btn-container">
        <Button type="submit" loading={loading} onClick={e => onNextClick(e)} pulse={pulseNextButton}>{nextButtonText}</Button>
      </div>
    </div>
  );
};

StepsHeader.propTypes = {
  onBackClick: PropTypes.func,
  activeStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired,
  nextText: PropTypes.string,
  onNextClick: PropTypes.func.isRequired,
  loading: PropTypes.bool,
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
  pulseNextButton: PropTypes.bool,
};

export default StepsHeader;



// WEBPACK FOOTER //
// ./library/app/components/Global/Misc/StepsHeader.js